/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
import uniqid from 'uniqid'

var AnimationTab = function (editor) {
  var signals = editor.signals

  var container = new UI.Panel()
  container.setId('animationTab')

  var selectedElement = null
  var selected = null

  // Animation editor default values
  var defaultAnimationIndex = 0
  var defaultNumberOfLoops = 1

  function build () {
    container.clear()
    if (selectedElement === null) {
      return
    }

    // Animation
    var dummy = new UI.Row()
    dummy.add(new UI.Text('').setWidth('90px'))
    container.add(dummy)

    // Select Animation
    var animationSelector = new UI.Row()
    animationSelector.add(new UI.Text('Animation Selector').setWidth('180px'))

    var animation = new UI.Select()
    let animationIndex = editor.animationItems
      .findIndex(animationItem => animationItem.name === selectedElement.animation.name)
    animation.setOptions(editor.animationItems.map((animationItem, i) => animationItem.name))
      .setValue(animationIndex)
    animation.onChange(function (e) {
      let changedAnimationSelectionIndex = this.getValue()
      let animationItemSelected = editor.animationItems[parseInt(changedAnimationSelectionIndex)]
      let animationItemSelectedDuration = parseFloat(animationItemSelected.duration)
      let newName = animationItemSelected.name
      selectedElement.animation.name = newName
      selectedElement.animation.animationId = editor.animationItems[changedAnimationSelectionIndex].animationId
      selectedElement.animation.iOS = editor.animationItems[changedAnimationSelectionIndex].asset_bundle.iOS.fileURL || 'N/A'
      selectedElement.animation.Android = editor.animationItems[changedAnimationSelectionIndex].asset_bundle.Android.fileURL || 'N/A'
      selectedElement.animation.endTime = selectedElement.animation.startTime + animationItemSelectedDuration
      pushElementsAfter(selectedElement)
      signals.animationModified.dispatch(selected)
    })
    animationSelector.add(animation)
    var animationButton = new UI.Button('Play')
      .setBorder('1px solid #fff').setPadding('4px').setBorderRadius('8px').setMargin('0 0 0 10px')
    animationButton.onClick(function () {
      signals.playAnimation.dispatch(selectedElement)
    })
    animationSelector.add(animationButton)
    container.add(animationSelector)

    // Enter Animation Start
    var animationStartTime = new UI.Row()
    animationStartTime.add(new UI.Text('Animation Start').setWidth('180px'))

    var animationStart = new UI.Text(selectedElement.animation.startTime).setWidth('45px')
    // var animationStart = new UI.Number(selectedElement.animation.startTime).setWidth('45px');
    // animationStart.onChange(function (e) {

    //     let animationStartTime = this.getValue();
    //     if (animationStart >= selected.start) {
    //         selectedElement.animation.startTime = animationStartTime
    //         signals.animationModified.dispatch(selected);
    //     }
    // });
    animationStartTime.add(animationStart)
    container.add(animationStartTime)

    // Number of Loops
    var loopNumber = new UI.Row()
    loopNumber.add(new UI.Text(`Number of Loops`).setWidth('180px'))

    let animationItemSelected = editor.animationItems.find(animationItem => animationItem.name === selectedElement.animation.name)
    let slider = new UI.Slider(1, 7, selectedElement.animation.loopCount, '').setWidth('180px')

    slider.onChange(function (e) {
      selectedElement.animation.loopCount = parseInt(e.target.value)
      selectedElement.animation.endTime = determineAnimationEndTime(animationItemSelected, selectedElement.animation.loopCount, selectedElement.animation.startTime)
      if (selected.end < selectedElement.animation.endTime) {
        selected.end = selectedElement.animation.endTime
      }
      pushElementsAfter(selectedElement)
      signals.animationModified.dispatch(selected)
    })
    loopNumber.add(slider)
    container.add(loopNumber)

    // Animation Position of destination
    var destinationPos = new UI.Row()
    destinationPos.add(new UI.Text('Animation Position of destination').setWidth('180px'))

    var [destinationPosX, destinationPosY, destinationPosZ] = selectedElement.animation.destination.position

    var destinationPosInput = new UI.Input(`(${destinationPosX}, ${destinationPosY}, ${destinationPosZ})`)
    destinationPosInput.onChange(function () {
      let val = this.getValue().substring(1, this.getValue().length - 1)
      let position = val.split(',').map(s => parseFloat(s.trim()))
      selectedElement.animation.destination.position[0] = position[0]
      selectedElement.animation.destination.position[1] = position[1]
      selectedElement.animation.destination.position[2] = position[2]
    })
    destinationPos.add(destinationPosInput)
    container.add(destinationPos)

    // Animation Rotation of destination
    var destinationRot = new UI.Row()
    destinationRot.add(new UI.Text('Animation Rotation of destination').setWidth('180px'))
    container.add(destinationRot)

    var [destinationRotX, destinationRotY, destinationRotZ] = selectedElement.animation.destination.rotation
    var destinationRotInput = new UI.Input(`(${destinationRotX}, ${destinationRotY}, ${destinationRotZ})`)
    destinationRotInput.onChange(function () {
      let val = this.getValue().substring(1, this.getValue().length - 1)
      let rotation = val.split(',').map(s => parseFloat(s.trim()))
      selectedElement.animation.destination.rotation[0] = rotation[0]
      selectedElement.animation.destination.rotation[1] = rotation[1]
      selectedElement.animation.destination.rotation[2] = rotation[2]
    })
    destinationRot.add(destinationRotInput)

    // Add Animation
    var addAnimation = new UI.Row()
    var animationContainer = new UI.Div()
    var addAnimationButton = new UI.Button('Add New Animation').setWidth('100%')

    addAnimationButton.onClick(function () {
      let newAnimation = _addNewAnimationElement(selected)
      signals.animationModified.dispatch(selected)
      signals.animationSubComponentSelected.dispatch(newAnimation, selected)
    })

    addAnimation.add(animationContainer)
    addAnimation.add(addAnimationButton)
    container.add(addAnimation)

    // Remove Animation
    // Only display if there are multiple animations
    if (selected.elements.filter(element => element.animation).length > 1) {
      var removeAnimation = new UI.Row()
      var animationRemovalContainer = new UI.Div()
      var animationRemovalButton = new UI.Button('Remove This Animation').setWidth('100%')

      animationRemovalButton.onClick(function () {
        selected.elements = selected.elements.filter(element => element !== selectedElement)
        signals.animationModified.dispatch(selected)
        signals.animationSelected.dispatch(null)
      })

      removeAnimation.add(animationRemovalContainer)
      removeAnimation.add(animationRemovalButton)
      container.add(removeAnimation)
    }
  }

  function pushElementsAfter (element) {
    let animationElement = element.animation
    let animationIndex = selected.elements.findIndex(el => el === element)

    let elementsToShift = selected.elements.filter((el, i) => el.animation && i > animationIndex && animationElement.endTime > el.animation.startTime)

    let nextStart = animationElement.endTime

    elementsToShift.forEach(el => {
      let orgDuration = el.animation.endTime - el.animation.startTime
      el.animation.startTime = nextStart
      el.animation.endTime = el.animation.startTime + orgDuration
      nextStart = el.animation.endTime
    })
    if (selected.end < nextStart) {
      selected.end = nextStart
    }
  }

  function determineNewAnimationElementStartTime (selected, animationItem) {
    let animationDuration = parseFloat(animationItem.duration)

    let lastAnimation = selected.elements.find(element => element.animation).animation
    selected.elements.forEach(element => {
      if (element.animation && element.animation.endTime > lastAnimation.endTime) {
        lastAnimation = element.animation
      }
    })

    let minEndTime = lastAnimation.endTime

    if ((minEndTime + animationDuration) < selected.end) {
      return minEndTime
    } else {
      selected.end = animationDuration + minEndTime
      signals.animationModified.dispatch(selected)
      return selected.end - animationDuration
    }
  }

  function determineAnimationEndTime (animationItem, numberOfLoops, startTime) {
    return (parseFloat(animationItem.duration) * numberOfLoops) + startTime
  }

  // note this method is duplicated in SettingTab.js
  function _addNewAnimationElement (selected) {
    let startTime = determineNewAnimationElementStartTime(selected, editor.animationItems[defaultAnimationIndex])
    let elementToAdd = {
      id: uniqid(),
      animation: {
        name: editor.animationItems[defaultAnimationIndex].name,
        animationId: editor.animationItems[defaultAnimationIndex].animationId,
        iOS: editor.animationItems[defaultAnimationIndex].asset_bundle.iOS.fileURL || 'N/A',
        Android: editor.animationItems[defaultAnimationIndex].asset_bundle.Android.fileURL || 'N/A',
        startTime: startTime,
        endTime: determineAnimationEndTime(editor.animationItems[defaultAnimationIndex], defaultNumberOfLoops, startTime),
        loopCount: defaultNumberOfLoops,
        destination: {
          position: [0, 0, 0],
          rotation: [0, 0, 0]
        },
        elements: []
      }
    }
    selected.elements.push(elementToAdd)
    return elementToAdd
  }

  signals.animationSubComponentSelected.add(function (el, animation) {
    if (el.animation) {
      selectedElement = el
      selected = animation
      build()
    }
  })

  signals.animationModified.add(function (animation) {
    selected = animation
    build()
  })

  signals.effectCompiled.add(build)

  return container
}

export default AnimationTab



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/AnimationTab.js
// module id = null
// module chunks = 